import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import BackButton from "../../../components/buttons/BackButton"
import { BASE_URL } from "../../../utils/Constants"
import { ExpertRole } from "../../../utils/Enums"

const EmailRegistrationCode = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const email = location.state.email
    const role = location.state.role
    const newsletterAccepted = location.state.newsletterAccepted
    const name = location.state.name
    const familyName = location.state.familyName
    const password = location.state.password

    const [isLoading, setIsLoading] = useState(false)

    const [confirmationCode, setConfirmationCode] = useState("")

    const onConfirmCodeClick = () => {
        callConfirmCodeAPI()
    }

    async function callConfirmCodeAPI() {
        console.log(email)
        console.log(confirmationCode)
        console.log(role)
        setIsLoading(true)
        const response = await fetch(`${BASE_URL}/auth/confirm`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                {
                    email: email,
                    code: confirmationCode,
                    role: role,
                }
            )
        })
        setIsLoading(false)
        if (!response.ok) {
            console.log("Errore")
        } else {
            const responseJson = await response.json()
            console.log(responseJson)
            callLoginAPI()
        }
    }

    // LOGIN Api
    async function callLoginAPI() {
        setIsLoading(true)
        const response = await fetch(`${BASE_URL}/auth/login`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                {
                    email: email,
                    password: password,
                    role: role,
                })
        })
        setIsLoading(false)
        if (!response.ok) {
        } else {
            // Se la chimata va a buon fine si va alla login success page
            const result = await response.json();
            if (result.role === ExpertRole.Admin) {
                navigate("/login")
            } else {
                const idToken = result.id_token
                const accessToken = result.access_token
                const userId = result.id
                const refreshToken = result.refresh_token
                const role = result.role
                console.log(role)
                navigate("/email-registration-complete-account", { state: { name, familyName, idToken, accessToken, userId, refreshToken } })
            }
        }
    }

    const confirmButonDisabled = confirmationCode.length < 6

    return (
        <div className="App">
            <div className={`h-[10%] w-full flex justify-center ${isLoading ? "opacity-30 pointer-events-none" : ""}`}>
                <div className="w-[90%] h-full flex items-center justify-between">
                    <BackButton
                        onClick={() => navigate("/email-registration", { state: { newsletterAccepted } })}
                    />
                </div>
            </div>
            <div className="h-[90%] w-full flex flex-col items-center justify-center">
                <div className="w-[392px] h-[488px] flex flex-col justify-center items-center bg-white">
                    <div className="w-[90%] h-[90%] flex flex-col justify-between items-center">
                        <div className="font-bold text-[30px] leading-[24px]">Inserisci codice</div>
                        <div className="font-normal text-[18px] leading-[26px] text-center">
                            Hai ricevuto per e-mail un codice a 6 cifre per verificare il tuo indirizzo e-mail. Inseriscilo qui sotto.
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Codice di verifica
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none placeholder:tracking-[1.5px]"
                                    type="text"
                                    placeholder="00000"
                                    onChange={(e) => setConfirmationCode(e.target.value)}
                                />
                            </div>
                        </div>
                        <button
                            className={`w-[328px] h-[55px] rounded-[5px] border-none text-white font-bold text-[14px] uppercase primary-action-color-background ${confirmButonDisabled ? "" : "cursor-pointer"}`}
                            onClick={onConfirmCodeClick}
                            disabled={confirmButonDisabled}
                        >
                            Conferma codice
                        </button>
                        <button className="w-[328px] h-[55px] rounded-[5px] border-none text-black font-bold text-[14px] uppercase bg-white cursor-pointer">
                            Invia nuovo codice
                        </button>
                    </div>
                </div>
            </div>
            <div className="h-[10%] w-full flex justify-center" />
        </div>
    )
}

export default EmailRegistrationCode
